import { ChangeDetectionStrategy, Component, Injector, ViewChild } from '@angular/core';
import { WidgetBase } from '../../widget-content/base/widget-base';
import { WidgetContentForumFeedComponent } from '../../widget-content/forum-feed/forum-feed.component';

@Component({
    selector: 'fi-widget-forum-feed',
    templateUrl: './forum-feed.component.html',
    styleUrls: ['./forum-feed.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-forum-feed' },
    standalone: false,
})
export class WidgetForumFeedComponent extends WidgetBase {
    constructor(injector: Injector) {
        super(injector);
    }

    @ViewChild(WidgetContentForumFeedComponent, { static: false }) forumFeedContent: WidgetContentForumFeedComponent;

    get isEmpty$() {
        return this.forumFeedContent.isEmpty$;
    }
}
